import flatMap from 'lodash/flatMap';
import { Feature, FeatureCollection, Geometry, LineString, Point } from '@turf/helpers';

export function combine(...featureCollections: FeatureCollection[]): FeatureCollection {
    return featureCollection(flatMap(featureCollections, it => it.features));
}

export function feature(geometry: Geometry, properties = {}): Feature {
    return {
        type: 'Feature',
        geometry,
        properties
    };
}

export function featureCollection(features: Feature[] = []): FeatureCollection {
    return {
        type: 'FeatureCollection',
        features
    };
}

export function lineString(coordinates: any, properties = {}) {
    return feature(
        {
            type: 'LineString',
            coordinates
        },
        properties
    );
}

export function point(coordinates: any, properties = {}) {
    return feature(
        {
            type: 'Point',
            coordinates
        },
        properties
    );
}
